import { IconButton, Tooltip } from "@mui/material";

export interface ActionsMenuEntryIcons {
  title: string;
  action: () => void;
  icon?: JSX.Element;
}

interface Props {
  onClick?: () => void;
  icon?: JSX.Element;
  tooltip: string;
}

function ViewActionButton({ tooltip, onClick, icon: IconComponent }: Props) {
  if (!IconComponent) return <>{tooltip}</>;

  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          width: 26,
          height: 26,
          color: "var(--text-tertiary)",
          "& .MuiSvgIcon-root": { fontSize: 17 },
          "&:hover": { color: "var(--text-primary)", backgroundColor: "var(--surface-hover)" },
        }}
      >
        {IconComponent}
      </IconButton>
    </Tooltip>
  );
}

export default ViewActionButton;
